import { Action } from "redux-actions";
import * as types from "../types";
import { createAction, ActionFunction0, ActionFunction1 } from "redux-actions";
//import { createAction as createThunkAction } from 'redux-actions-helper';
export function CreateSimpleActionReducer1<T>(
  reducers: any,
  funcName: string,
  action: (obj: T) => T,
  reducer: (state: types.IState, payload?: T) => types.IState
): ActionFunction1<T, Action<T>> {
  reducers[funcName] = (
    state: types.IState,
    action: Action<T>
  ): types.IState => {
    var newState = { ...state };
    return reducer(newState, action.payload);
  };
  const actionFunction = createAction<T, T>(funcName, action);
  return actionFunction;
}

export function CreateSimpleReducer1<T>(
  reducers: any,
  funcName: string,
  reducer: (state: types.IState, payload?: T) => types.IState
): ActionFunction1<T, Action<T>> {
  reducers[funcName] = (
    state: types.IState,
    action: Action<T>
  ): types.IState => {
    var newState = { ...state };
    return reducer(newState, action.payload);
  };
  let func = function(obj: T): T {
    return obj;
  };
  const action = createAction<T, T>(funcName, func);
  return action;
}

export function CreateSimpleReducer0(
    reducers: any,
    funcName: string,
    reducer: (state: types.IState, payload?: void) => types.IState
  ): ActionFunction0<void> {
    reducers[funcName] = (
      state: types.IState,
      action: Action<void>
    ): types.IState => {
      var newState = { ...state };
      return reducer(newState, action.payload);
    };
    let func = function(): void {
      return;
    };
    const action = createAction(funcName, func);
    return action;
  }


// WEBPACK FOOTER //
// ./src/reducers/reducer-helper.ts